import { createTheme } from '@material-ui/core/styles';

export function createVseTheme() {
  const vsePalette = {
    background: {
      paper: "rgba(255, 255, 255, 1)",
      default: "rgba(255, 255, 255, 1)",
    },
    action: {
      disabledBackground: "rgba(163, 163, 163, 0.12)",
    },
    primary: {
      // light: will be calculated from main,
      main: "rgba(102, 45, 145, 1)",
      // dark: will be calculated from main,
      // contrastText: will be calculated to contrast with main
    },
    secondary: {
      // light: will be calculated from main,
      main: "rgba(27, 176, 178, 0.87)",
      // dark: will be calculated from main,
      // contrastText: will be calculated to contrast with main
    },
    text: {
      primary: "rgba(0, 0, 0, 0.87)",
      secondary: "#1bafb2",
      disabled: "rgba(0, 0, 0, 0.38)",
      hint: "rgba(0, 0, 0, 0.38)",
    },
  };

  const vseTypography = {
    h1: {
      color: vsePalette.primary.main,
    },
    h2: {
      color: vsePalette.primary.main,
    },
    h3: {
      color: vsePalette.primary.main,
    },
    h4: {
      color: vsePalette.primary.main,
    },
    h5: {
      color: vsePalette.primary.main,
    },
    h6: {
      color: vsePalette.primary.main,
    },
    subtitle1: {
      color: vsePalette.secondary.main,
    },
    subtitle2: {
      color: vsePalette.secondary.main,
    },
  }

  let theme = createTheme({
    palette: vsePalette,
    typography: vseTypography,
  });

  return {
    ...theme,
    props: {
      MuiGrid: {
        spacing: 2,
      },
      MuiPaper: {
        elevation: 3,
      },
      MuiTable: {
        size: 'small',
      },
      MuiToolbar: {
        variant: 'dense',
      },
    },
    overrides: {
      MuiFormControl: {
        root: {
          width: '100%',
        }
      },
      MuiGrid: {
        container: {
          paddingBottom: theme.spacing(2),
        },
      },
      MuiTabs: {
        root: {
          marginLeft: theme.spacing(1),
        },
        indicator: {
          height: 3,
          borderTopLeftRadius: 3,
          borderTopRightRadius: 3,
          backgroundColor: theme.palette.common.white,
        },
      },
      MuiTab: {
        root: {
          margin: '0 16px',
          minWidth: 0,
          padding: 0,
          [theme.breakpoints.up('md')]: {
            padding: 0,
            minWidth: 0,
          },
        },
      },
      MuiTable: {
        root: {
          '& caption': {
            captionSide: 'top',
            padding: theme.spacing(0, 2, 0, 2),
            fontWeight: theme.typography.fontWeightBold,
          },
        },
      },
      MuiTableCell: {
        head: {
          color: vsePalette.secondary.main,
        },
      },
    },
  };
}
